import { s24 } from '@ardoq/design-tokens';
import { Box } from '@ardoq/layout';
import styled from 'styled-components';
import { t, type I18nLocale } from '@ardoq/i18n';

type SurveyErrorOrWarningPopoverProps = {
  errorMessages: string[];
  warningMessages: string[];
  i18nLocale?: I18nLocale;
};

const ListContainer = styled.ul`
  padding-inline-start: ${s24};
`;

export const SurveyErrorOrWarningPopover = ({
  errorMessages,
  warningMessages,
  i18nLocale = {},
}: SurveyErrorOrWarningPopoverProps) =>
  errorMessages.length || warningMessages.length ? (
    <Box maxWidth="500px">
      {errorMessages.length > 0 && (
        <>
          <p>
            {t(i18nLocale, 'surveyAdmin:overview.errorsFound', 'Errors found:')}
          </p>
          <ListContainer>
            {errorMessages.map((message, index) => (
              <li key={index}>{message}</li>
            ))}
          </ListContainer>
        </>
      )}
      {warningMessages.length > 0 && (
        <>
          <p>
            {t(
              i18nLocale,
              'surveyAdmin:overview.warningsFound',
              'Warnings found:'
            )}
          </p>
          <ListContainer>
            {warningMessages.map((message, index) => (
              <li key={index}>{message}</li>
            ))}
          </ListContainer>
        </>
      )}
    </Box>
  ) : null;
